module.exports = __webpack_public_path__ + "img/background22.f2224db4.jpg";